<div class="business-navbar__text-area__wrapper" [ngClass]="{'business-navbar__text-area__wrapper--focused': isFocused, 'business-navbar__text-area__wrapper--not-empty': !!text}">
    <div class="business-navbar__text-area__field__flex">
        <div class="business-navbar__text-area__field-infix">
            <textarea class="business-navbar__text-area__text" (focus)="focused(true)" (focusout)="focused(false)" [(ngModel)]="text" (ngModelChange)="textChange.emit(text)" [ngStyle]="{'max-height': maxHeightStyle, 'height': heightStyle}"></textarea>
            <span class="business-navbar__text-area__label">
                <label class="business-navbar__text-area__label__text">{{ prescriptionText }}</label>
            </span>
        </div>
    </div>
    <div class="business-navbar__text-area__field-underline">
        <span class="business-navbar__text-area__field-underline__field-ripple"></span>
    </div>
    <div class="business-navbar__text-area__character-limit" *ngIf="limit > 0">
        <span class="business-navbar__text-area__character-limit__text" [ngClass]="{'business-navbar__text-area__character-limit__text--over-limit': text?.length > limit}">
            {{ (text?.length) ? text?.length : 0 }} / {{ limit }}
        </span>
    </div>
</div>
